/* eslint-disable @typescript-eslint/camelcase */
import { CourseReducerType } from 'types/course.type';
import { calculateWeeks } from 'utils/term.util';
import * as type from './course.constants';

const initialState: CourseReducerType = {
  searchDataLoading: false,
  searchData: null,
  searchDataError: false,
  skillsLoading: false,
  skills: null,
  skillsError: false,
  advisorsLoading: false,
  advisors: null,
  advisorsError: false,
  postsLoading: false,
  posts: null,
  postsError: false,
  chapters: null,
  termWeeks: null,
  termWeeksError: false,
  termList: null,
  termData: null,
};

// eslint-disable-next-line default-param-last
const courseReducer = (state = initialState, action): CourseReducerType => {
  switch (action.type) {
    case type.GET_POSTS_REQUEST:
      return { ...state, postsLoading: true, posts: null, postsError: false };
    case type.GET_POSTS_SUCCESS:
      return {
        ...state,
        postsLoading: false,
        posts: action.payload,
        postsError: false,
      };
    case type.GET_POSTS_ERROR:
      return { ...state, postsLoading: false, posts: null, postsError: true };
    case type.SAVE_TERM_WEEKS:
      return { ...state, termWeeks: action.payload, termWeeksError: false };
    case type.SAVE_TERM_WEEKS_ERROR:
      return { ...state, termWeeksError: true };
    case type.UPDATE_TERM_PASSED: {
      const { weekHours, days } = state.termData;
      const termList = [...state.termList].map((item) =>
        item.lesson_id === Number(action.lessonId) ? { ...item, passed: true } : item,
      );
      const termWeeks = calculateWeeks(termList, days, weekHours);
      return { ...state, termList, termWeeks };
    }

    case type.GET_SEARCH_DATA_REQUEST:
      return {
        ...state,
        searchDataLoading: true,
        searchData: null,
        searchDataError: false,
      };
    case type.GET_SEARCH_DATA_SUCCESS:
      return {
        ...state,
        searchDataLoading: false,
        searchData: action.payload,
        searchDataError: false,
      };
    case type.GET_SEARCH_DATA_ERROR:
      return {
        ...state,
        searchDataLoading: false,
        searchData: null,
        searchDataError: true,
      };

    case type.GET_SKILLS_REQUEST:
      return {
        ...state,
        skillsLoading: true,
        skills: null,
        skillsError: false,
      };
    case type.GET_SKILLS_SUCCESS:
      return {
        ...state,
        skillsLoading: false,
        skills: action.payload,
        skillsError: false,
      };
    case type.GET_SKILLS_ERROR:
      return {
        ...state,
        skillsLoading: false,
        skills: null,
        skillsError: true,
      };

    case type.GET_ADVISORS_REQUEST:
      return {
        ...state,
        advisorsLoading: true,
        advisors: null,
        advisorsError: false,
      };
    case type.GET_ADVISORS_SUCCESS:
      return {
        ...state,
        advisorsLoading: false,
        advisors: action.payload,
        advisorsError: false,
      };
    case type.GET_ADVISORS_ERROR:
      return {
        ...state,
        advisorsLoading: false,
        advisors: null,
        advisorsError: true,
      };

    case type.CLEAR_STORE:
      return { ...state, chapters: null };
    case type.GET_CHAPTER_REQUEST:
      return {
        ...state,
        chapters: {
          ...state.chapters,
          [action.id]: { ...state.chapters?.[action.id], loading: true }, // not show loading when user register a course
        },
      };
    case type.GET_CHAPTER_SUCCESS:
      return {
        ...state,
        chapters: {
          ...state.chapters,
          [action.id]: { loading: false, data: action.payload, error: null },
        },
      };
    case type.GET_CHAPTER_ERROR:
      return {
        ...state,
        chapters: {
          ...state.chapters,
          [action.id]: { loading: true, data: null, error: true },
        },
      };

    default:
      return state;
  }
};

export default courseReducer;
